export const NO_OF_RECORDS = "20";
export const SERIAL_NUMBER = "18bdaee";
export const CLIENT_NAME = "DS TEA BOARD INDIA 1";
